<template>
    <div>
        <div>
            <img :src="(photo.link.url).replace('#', '%23')" v-show="Photo" @load="loadPhoto" id="Photo" class="user_view__images__item__image" @click="handleClickImage(photo.link.url)"/>
            <img :src="(photo.link1.url).replace('#', '%23')" v-show="Photo1" @load="loadPhoto" id="Photo1" class="user_view__images__item__image" @click="handleClickImage(photo.link1.url)"/>
            <img :src="(photo.link2.url).replace('#', '%23')" v-show="Photo2" @load="loadPhoto" id="Photo2" class="user_view__images__item__image" @click="handleClickImage(photo.link2.url)"/>
            <img :src="(photo.link3.url).replace('#', '%23')" v-show="Photo3" @load="loadPhoto" id="Photo3" class="user_view__images__item__image" @click="handleClickImage(photo.link3.url)"/>
            <img :src="(photo.link4.url).replace('#', '%23')" v-show="Photo4" @load="loadPhoto" id="Photo4" class="user_view__images__item__image" @click="handleClickImage(photo.link4.url)"/>
        </div>
        <div class="user_view__images__item__hour">
            <p class="user_view__images__item--hourItem">Tomada a las {{photo.hour}}</p>
            
        </div>
    </div>
</template>
<script>
export default {
    props:{
        photo: Object
    },
    data() {
        return {
            Photo: false,
            Photo1: false,
            Photo2: false,
            Photo3: false,
            Photo4: false,
        }
    },
    methods:{
        handleClickImage(url){
            window.open(url, "_blank")
        },
        loadPhoto(e){
            e.target.id == "Photo" ? this.Photo = true : '';
            e.target.id == "Photo1" ? this.Photo1 = true : '';
            e.target.id == "Photo2" ? this.Photo2 = true : '';
            e.target.id == "Photo3" ? this.Photo3 = true : '';
            e.target.id == "Photo4" ? this.Photo4 = true : '';
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PhotoItem.vue